import React, { useState, useEffect } from "react";
import LayoutHOC from "../LayoutHOC";
import { pushAlert } from "../../utils/alertSlice";
import { useDispatch } from "react-redux";
import { useFetchAllSectionsQuery } from "../../utils/customer/customerSelect";
import { TemplateBuilder } from "./TemplateBuilder";
import { useParams } from "react-router-dom";

const CustomModulePage = () => {
  // const [type, setType] = useState("template");
  const [sectionDetails, setSectionDetails] = useState({});
  const [sectionID, setSectionID] = useState(null);
  const [sectionlist, setSectionlist] = useState(null);

  const { id: templateId } = useParams();
  // const templateId = "6e48663c-8f14-11f0-b592-bc2411f4d589";

  const dispatch = useDispatch();

  const {
    data: AllSections,
    refetch: RefetchAllSections,
    isError: isAllSectionsError,
    isSuccess: isAllSectionsSuccess,
    error: AllSectionsError,
  } = useFetchAllSectionsQuery();

  // 🔁 HANDLE GET ALL SECTIONS
  useEffect(() => {
    if (isAllSectionsSuccess && AllSections?.success) {
      setSectionlist(AllSections.data);
      dispatch(pushAlert({ message: AllSections.message, type: "success", visible: true }));

      const matched = AllSections?.data?.find((obj) => obj?.id === sectionID);
      setSectionDetails(matched || AllSections?.data[AllSections?.data?.length - 1]);
    }

    if (isAllSectionsError) {
      dispatch(
        pushAlert({
          message: AllSectionsError?.data?.message || "Error fetching sections",
          type: "danger",
          visible: true,
        })
      );
    }
  }, [AllSections, isAllSectionsSuccess, isAllSectionsError]);

  return (
    <>
      <div className="w-full h-full p-3 overflow-hidden">
        <div className=" h-full rounded-lg overflow-hidden">
          <TemplateBuilder templateId={templateId} />
        </div>
      </div>
    </>
  );
};

export default LayoutHOC(CustomModulePage);
